import React from "react"
import { Box, Container, Flex, Grid, Heading, Text, Image } from "theme-ui"
import AccordionClosed from "../images/accordion-closed.inline.svg"
import { MagicLink } from "../utils/magicLink"
import { GatsbyImage } from "gatsby-plugin-image"
import ArrowLink from "./arrowLink"
import HomeImageMobile from "../images/home-mobile-1.png"

const HomeHeader = ({ block }) => {
  const { title, description, link } = block
  const blockImage = block.image

  return (
    <Box
      sx={{
        minHeight: ["374px","474px","764px","764px"],
        height: ["auto", "auto", "100vh"],
        position: "relative",
      }}
    >
      <Grid
        columns={["1fr", "1fr", ".45fr .55fr"]}
        gap={[0, 0]}
        sx={{
          height: "100%",
          alignItems: ["flex-start", "flex-start", "flex-end"],
        }}
      >
        <Box
          sx={{
            backgroundColor: "primary",
            height: "100%",
            px: [3],
            display: "flex",
            flexDirection: "column",
            justifyContent: ["flex-start", "flex-start", "flex-end"],
            alignItems: "center",
            py: [4, 6],
            mb: ["-20%", "-20%", "auto"],
          }}
        >
          <Heading
            as="div"
            variant="h1"
            sx={{
              maxWidth: ["100%", "100%", "779px"],
              h1: {
                my: [0, 0],
                fontSize: ["12vw", "11vw", "7.5rem"],
                fontWeight: "300",
                textTransform: "uppercase",
                lineHeight: "1.067",
              },
              color: "light",
            }}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <Text
            as="div"
            sx={{
              display: ["none", "none", "block"],
              maxWidth: "734px",
              color: "light",
            }}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </Box>
        <Box
          sx={{
            display: ["block", "block", "none"],
            transform: "translateY(40%)",
          }}
        >
          <Image src={HomeImageMobile} />
        </Box>
        <Flex
          sx={{
            justifyContent: ["flex-start", "flex-start", "flex-end"],
            alignItems: ["flex-start", "flex-start", "flex-end"],
            height: "100%",
            pt: [8, 10, 0],
            backgroundColor: "light",
          }}
        >
          <Container
            sx={{
              display: "flex",
              justifyContent: ["flex-start", "flex-start", "flex-end"],
              alignItems: ["flex-start", "flex-start", "flex-end"],
              flexDirection: "column",
              width: "100%",
              height: "100%",
              position: "relative",
            }}
          >
            {/* {blockImage && (
              <Box
                sx={{
                  position: "absolute",
                  top: ["-70%", "-70%", "50%"],
                  transform: [
                    "translate(0%,0%)",
                    "translate(0%,0%)",
                    "translate(-32%,-50%)",
                  ],
                  left: 0,
                  maxHeight: ["285px", "285px", "100%"],
                  height: ["285px", "285px", "100%"],
                  ".gatsby-image-wrapper": {
                    height: "100%",
                    img: {
                      objectFit: "contain!important",
                    },
                  },
                }}
              >
                <GatsbyImage image={blockImage.gatsbyImageData} alt="" />
              </Box>
            )} */}
            <Text
              as="div"
              sx={{
                maxWidth: "734px",
                color: "primary",
                display: ["block", "block", "none"],
              }}
              dangerouslySetInnerHTML={{ __html: description }}
            />
            <Flex
              sx={{
                zIndex: 999,
                width: "100%",
                maxWidth: "734px",
                alignItems: "center",
                textTransform: "uppercase",
                fontWeight: "400",

                justifyContent: "space-between",
                pt: [2, 3, 3, 4],
                mt: [2, 3, 3, 5],
                borderTop: "2px solid",
                borderColor: "primary",
                a: {
                  textDecoration: "none",
                  // "&:hover": {
                  //   color: "dark",
                  // },
                },
              }}
            >
              <MagicLink
                item={link}
                locale={link.locale}
                sx={{
                  fontSize: [3, 4, 4, 5],
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  alignItems: "center",
                  color: "primary",
                  svg: {
                    fill: "primary",
                    transition: "all .2s ease",
                  },
                  "&:hover": {
                    svg: {
                      fill: "primary",
                      transform: "rotate(45deg)",
                      transition: "all .2s ease",
                    },
                  },
                }}
              >
                <Box sx={{ mr: [2] }}>{link.anchor}</Box>
                <Box
                  sx={{
                    maxWidth: ["50%", "75%", "75%", "100%"],
                    svg: {
                      maxWidth: ["28px", "39px"],
                      maxHeight: ["28px", "39px"],
                    },
                  }}
                >
                  <AccordionClosed />
                </Box>
              </MagicLink>
            </Flex>
          </Container>
        </Flex>
      </Grid>
    </Box>
  )
}

export default HomeHeader
